import React, { ReactElement, ReactNode } from 'react';
import { FormattedText } from '@/components/uiKit/FormattedText';

interface FormLayoutProps {
  title: string;
  subtitle: string;
  middleRow?: string;
  icon?: ReactElement;
  children?: ReactNode;
}

export const FormLayout = ({ title, subtitle, middleRow, icon, children }: FormLayoutProps) => {
  return (
    <div className="flex flex-col h-full justify-center px-4">
      <div className="max-w-[26.25rem] min-w-full sm:min-w-[26.25rem] bg-white xl:bg-transparent rounded-lg xl:rounded-none px-6 py-12 xl:py-0">
        <div className="text-center xl:text-left">
          {icon}
        </div>

        <div>
          <h1 className="text-2xl font-semibold w-full xl:w-auto text-center xl:text-left">
            <FormattedText label={title} />
          </h1>
        </div>

        {middleRow && (
          <div className="pt-6 text-center xl:text-left">
            <FormattedText label={middleRow} />
          </div>
        )}

        <div className="pt-6 pb-10 text-center xl:text-left">
          <FormattedText label={subtitle} />
        </div>

        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};